import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { QuestionBase } from "../../../shared/components/dynamic-form/question-base";
import { TextboxQuestion } from "../../../shared/components/dynamic-form/question-textbox";

@Injectable()
export class DashboardService {
  constructor() {}

  generateQuestions(): Observable<QuestionBase<string | boolean>[]> {
    const questions: QuestionBase<string | boolean>[] = [
      new TextboxQuestion({
        value: "title",
        key: "title",
        label: "title",
        order: 1,
        hide: true,
      }),
    ];
    return of(questions.filter((field) => field).sort((a, b) => a.order - b.order));
  }
}
